import { EmptyState } from '@gorila-shared-ui/components';
import { StyledHead, StyledHeadCell, StyledTable } from 'baseui/table';
import { useParams } from 'react-router-dom';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeList as List } from 'react-window';
import { useRecoilValue } from 'recoil';
import { SMALL_LIST_ITEM_HEIGHT } from '../../constants/app';
import { TRACKING_COLUMNS } from '../../constants/tracking';
import { useStyles } from '../../hooks/useStyles';
import { reversedAssetStates } from '../../storage/tracking';
import TrackingRow from './TrackingRow';

export function TrackingTable() {
  const { css } = useStyles();
  const { assetId } = useParams();
  const states = useRecoilValue(reversedAssetStates(assetId || ''));

  if (!states || !states.length) {
    return <EmptyState title="No hay reportes del vehiculo desde que se incio el seguimiento" />;
  }

  return (
    <StyledTable $style={{ overflow: 'hidden' }}>
      <StyledHead>
        {TRACKING_COLUMNS.map((column, index) => (
          <StyledHeadCell
            key={index}
            style={{
              flex: column.size,
              maxWidth: column.maxWidth ? `${column.maxWidth}px` : undefined,
              justifyContent: column.centered ? 'center' : undefined,
            }}
          >
            {column.title}
          </StyledHeadCell>
        ))}
      </StyledHead>
      <div className={css({ flex: 1 })}>
        <AutoSizer>
          {({ width, height }) => (
            <List
              height={height ? height : 500}
              itemCount={states.length}
              itemSize={() => SMALL_LIST_ITEM_HEIGHT}
              width={width ? width : 500}
              itemData={states}
            >
              {TrackingRow}
            </List>
          )}
        </AutoSizer>
      </div>
    </StyledTable>
  );
}
